import request from 'superagent';

export default async function getNearbyShape({ coords, travelMode, travelTime }) {
  const proxy = await request.post('/portal-srp/api/v1/smartsuggest/getnearbyshape')
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .withCredentials()
    .send({
      coords: coords,
      travelMode: travelMode,
      travelTime: travelTime,
    });

  if (proxy && proxy.status === 200) {
    const { body } = proxy;
    return body?.nearbyshape || null;
  }
  return null;
}
